import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { EventCategories, EventActions } from '../../../../constants/Analytics';
import { Theme } from 'hui/src/styled';
import ConfirmationPopup from './ConfirmationPopup';
import FormProgress from './FormProgress';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
`;

const BackButton = styled.a`
  flex-direction: row;
  font-size: 1rem;
  cursor: pointer;
  color: ${Theme.greyMedium};
  & :hover {
    color: ${Theme.greyLight};
  }
`;

const BackArrow = () => (
  <svg width="12px" height="18px" viewBox="0 0 12 18">
    <g id="Back-arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group" transform="translate(1.000000, 0.000000)" fill="#A1A1A3">
        <rect
          id="Rectangle"
          transform="translate(5.126524, 5.636524) rotate(45.000000) translate(-5.126524, -5.636524) "
          x="3.87652416"
          y="-0.363475846"
          width="2.5"
          height="12"
          rx="1.25"
        />
        <rect
          id="Rectangle"
          transform="translate(5.126524, 12.354039) rotate(45.000000) translate(-5.126524, -12.354039) "
          x="-0.873475836"
          y="11.1040386"
          width="12"
          height="2.5"
          rx="1.25"
        />
      </g>
    </g>
  </svg>
);

const UserActions = props => {
  const { back, close, category, step, progress } = props;
  return (
    <Container>
      <BackButton
        onClick={back}
        data-ga-interactive={false}
        data-ga-category={EventCategories.POST_JOB_MODAL}
        data-ga-action={EventActions.PRESS_BACK_STARTBY_SCREEN}
        data-ga-label={category}
      >
        <BackArrow />
      </BackButton>
      <FormProgress progressValue={progress} />
      <ConfirmationPopup close={close} step={step} getCurrentCategory={category} />
    </Container>
  );
};

export default UserActions;

UserActions.propTypes = {
  back: PropTypes.func,
  close: PropTypes.func,
  category: PropTypes.string,
  progress: PropTypes.string,
  step: PropTypes.string
};
